/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit} from "@angular/core";

@Component ({
    selector: 'app-custom-fields',
    templateUrl: './customFields.component.html',
    styleUrls: ['./customFields.component.css'],
})
export class CustomFieldsComponent implements OnInit {
    roleDropDownSettings;
    roleSelectedItems;
    mUserAndTags;
    duplicateUserRoles;
    deleteUserRoleQuery;
    selectRoleItem;
    deselectRoleItem;
    selectAllRoleItems;
    deselectAllRoleItems;
    roleDropDownList;

    constructor() { }

    ngOnInit(): void {

    }
}
